import React, { ComponentProps } from "react";

import { FeatureGuard } from "@/components/elements/FeatureGuard";
import { useCurrentPlan } from "@/features/subscription";

export function AuthorizationLinkFeatureGuard(
  props: {
    children: React.ReactNode;
  } & Pick<ComponentProps<typeof FeatureGuard>, "fallback">,
) {
  const { enabled, loading } = useAuthorizationLinkFeatureGuard();
  return (
    <FeatureGuard test={enabled} loading={loading} fallback={props.fallback}>
      {props.children}
    </FeatureGuard>
  );
}

function useAuthorizationLinkFeatureGuard() {
  const { features, loading } = useCurrentPlan();
  return {
    enabled: features.externalAuthorization,
    loading,
  };
}
